interface Props {
  mensagem: string
  detalhe?: string
  onConfirm: () => void
  onCancel: () => void
  labelConfirm?: string
  labelCancel?: string
  tipo?: 'danger' | 'warning' | 'info'
}

const CORES = {
  danger:  { btn:'#dc2626', hover:'#b91c1c', icon:'🗑️' },
  warning: { btn:'#d97706', hover:'#b45309', icon:'⚠️' },
  info:    { btn:'#0ea5e9', hover:'#0284c7', icon:'ℹ️' },
}

export default function Confirm({ mensagem, detalhe, onConfirm, onCancel,
  labelConfirm='Confirmar', labelCancel='Cancelar', tipo='danger' }: Props) {
  const c = CORES[tipo]
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)',
      zIndex:10000, display:'flex', alignItems:'center', justifyContent:'center' }}
      onClick={onCancel}>
      <div style={{ background:'#1a2744', border:'1px solid #2d4166', borderRadius:12,
        padding:28, maxWidth:400, width:'90%', fontFamily:'Inter,sans-serif',
        boxShadow:'0 20px 60px rgba(0,0,0,0.5)' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ fontSize:32, textAlign:'center', marginBottom:12 }}>{c.icon}</div>
        <div style={{ fontSize:15, fontWeight:700, color:'#f1f5f9',
          textAlign:'center', marginBottom:8 }}>{mensagem}</div>
        {detalhe && <div style={{ fontSize:12, color:'#64748b',
          textAlign:'center', marginBottom:20 }}>{detalhe}</div>}
        {!detalhe && <div style={{ marginBottom:20 }} />}
        <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
          <button onClick={onCancel}
            style={{ flex:1, padding:'10px 0', borderRadius:8, border:'1px solid #2d4166',
              background:'#0d1b2e', color:'#94a3b8', cursor:'pointer',
              fontSize:13, fontFamily:'Inter', fontWeight:600 }}>
            {labelCancel}
          </button>
          <button onClick={onConfirm}
            style={{ flex:1, padding:'10px 0', borderRadius:8, border:'none',
              background:c.btn, color:'white', cursor:'pointer',
              fontSize:13, fontFamily:'Inter', fontWeight:700 }}>
            {labelConfirm}
          </button>
        </div>
      </div>
    </div>
  )
}
